import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Document {
  id: string;
  title: string;
  content: string;
  error: string;
}

interface DocumentsState {
  documents: Document[];
  activeDocumentId: string | null;
}

const initialState: DocumentsState = {
  documents: [],
  activeDocumentId: null,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    createDocument(state) {
      const newDoc = {
        id: Date.now().toString(),
        title: `Untitled Document ${state.documents.length + 1}`,
        content: "",
        error:null
      };
      state.documents.push(newDoc);
      state.activeDocumentId = newDoc.id;
    },
    updateDocument(state, action: PayloadAction<{ id: string; content: string }>) {
      const doc = state.documents.find((d) => d.id === action.payload.id);
      if (doc) {
        doc.content = action.payload.content;
      }
    },
    deleteDocument(state, action: PayloadAction<string>) {
      state.documents = state.documents.filter((doc) => doc.id !== action.payload);
      if (state.activeDocumentId === action.payload) {
        state.activeDocumentId = state.documents.length ? state.documents[0].id : null;
      }
    },
    setActiveDocument(state, action: PayloadAction<string>) {
      state.activeDocumentId = action.payload;
    },
    renameDocument(state, action: PayloadAction<{ id: string; title: string }>) {
      const doc = state.documents.find((d) => d.id === action.payload.id);
      if(action.payload.title == '') {
        doc.error = "Title cannot be empty!";
      }
      else if(state.documents.find((d) => d.title === action.payload.title && d.id !== action.payload.id)){
        doc.error = "Title cannot be duplicate!";
      }
      else {
        doc.error = null;
      }

      if (doc) {
        doc.title = action.payload.title;
      }
    },
    setDocuments(state, action: PayloadAction<Document[]>) {
      state.documents = action.payload;
      state.activeDocumentId = action.payload.length ? action.payload[0].id : null;
    },
  },
});

// Export actions
export const {
  createDocument,
  updateDocument,
  deleteDocument,
  setActiveDocument,
  renameDocument,
  setDocuments,
} = documentsSlice.actions;

// Export reducer
export default documentsSlice.reducer;
